import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-playstore-info-modal',
  templateUrl: './playstore-info-modal.component.html',
  styleUrls: ['./playstore-info-modal.component.scss']
})
export class PlaystoreInfoModalComponent {
  @ViewChild('playStoreModal') playStoreTemplate!: TemplateRef<PlaystoreInfoModalComponent>;
}
